import {
  createFailAction,
  createSuccessAction,
} from '../../../redux-util/async-helpers';
import { UPDATE_ADOPTION_ASSETS } from '../../bridge-method-remap';
import { getUid } from '../../../../utils/uid';

export default function(state = [], action) {
  const success = createSuccessAction(UPDATE_ADOPTION_ASSETS).type;
  const fail = createFailAction(UPDATE_ADOPTION_ASSETS).type;

  if (action.type === success || action.type === fail) {
    const changeData = {
      params: action.args[0].adoptions,
      success: action.type === success,
      id: getUid(),
    };
    return [changeData, ...state];
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/adoptions/assetChanges/reducer.js